<div class="login-page">
  <div class="login-shell">
    <section class="login-brand-panel">
      <div class="brand-mark">
        <img
          class="brand-mark__logo"
          src="assets/img/logo.png"
          alt="RB Clínica Dental"
        />
      </div>
      <p class="brand-description">{{ 'login.description' | translate }}</p>
    </section>

    <section class="login-card">
      <div class="login-language" aria-label="Language">
        @for (language of languages; track language) {
          <button
            type="button"
            [class.active]="currentLanguage === language"
            (click)="changeLanguage(language)"
          >
            {{ language.toUpperCase() }}
          </button>
        }
      </div>
      @if (!recoveryMode) {
      <div class="login-card__header">
        <h2>{{ 'login.title' | translate }}</h2>
        <p class="subtitle">{{ 'login.subtitle' | translate }}</p>
      </div>

      <form class="login-form" (ngSubmit)="submit()">
        <div class="form-group">
          <label for="username">{{ 'login.identifier' | translate }}</label>
          <div class="input-shell">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5Z"
                />
              </svg>
            </span>
            <input
              id="username"
              name="username"
              type="text"
              [(ngModel)]="username"
              autocomplete="username"
              maxlength="254"
              autocapitalize="none"
              autocorrect="off"
              spellcheck="false"
              required
            />
          </div>
        </div>

        <div class="form-group">
          <label for="password">{{ 'login.password' | translate }}</label>
          <div class="input-shell input-shell--password">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M17 10V8a5 5 0 0 0-10 0v2H5v10h14V10Zm-8 0V8a3 3 0 0 1 6 0v2Zm3 7a2 2 0 0 1-1-3.732V12h2v1.268A2 2 0 0 1 12 17Z"
                />
              </svg>
            </span>
            <input
              id="password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="password"
              autocomplete="current-password"
              maxlength="128"
              required
            />
            <button
              class="password-visibility"
              type="button"
              [attr.aria-label]="
                (showPassword ? 'login.hidePassword' : 'login.showPassword') | translate
              "
              [attr.aria-pressed]="showPassword"
              (click)="togglePasswordVisibility()"
            >
              <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
                @if (showPassword) {
                <path
                  d="M3 3l18 18M10.6 10.7a2 2 0 0 0 2.7 2.7M9.9 4.3A10.7 10.7 0 0 1 12 4c5.5 0 9 6 9 6a18 18 0 0 1-2.2 2.9M6.6 6.6C4.3 8.2 3 10 3 10s3.5 6 9 6a9.8 9.8 0 0 0 3.4-.6"
                />
                } @else {
                <path
                  d="M3 12s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6Zm9 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                />
                }
              </svg>
            </button>
          </div>
        </div>

        <button class="recovery-link" type="button" (click)="openRecovery()">
          {{ 'login.forgot' | translate }}
        </button>

        <button class="submit-button" type="submit" [disabled]="loading">
          @if (loading) { {{ 'login.entering' | translate }} }
          @if (!loading) { {{ 'login.submit' | translate }} }
        </button>
      </form>
      } @else if (!recoverySent) {
      <div class="login-card__header">
        <h2>{{ 'login.resetTitle' | translate }}</h2>
        <p class="subtitle">{{ 'login.resetHelp' | translate }}</p>
      </div>

      <form class="login-form" (ngSubmit)="submitRecovery()">
        <div class="form-group">
          <label for="recovery-identifier">{{ 'login.identifier' | translate }}</label>
          <div class="input-shell">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5Z"
                />
              </svg>
            </span>
            <input
              id="recovery-identifier"
              name="recoveryIdentifier"
              type="text"
              [(ngModel)]="recoveryIdentifier"
              autocomplete="email"
              maxlength="254"
              autocapitalize="none"
              autocorrect="off"
              spellcheck="false"
              required
            />
          </div>
        </div>

        <button
          class="submit-button"
          type="submit"
          [disabled]="recoveryLoading"
        >
          {{
            recoveryLoading
              ? ('login.sending' | translate)
              : ('login.requestReset' | translate)
          }}
        </button>
        <button
          class="secondary-button"
          type="button"
          (click)="closeRecovery()"
        >
          {{ 'login.back' | translate }}
        </button>
      </form>
      } @else {
      <div class="recovery-confirmation" role="status">
        <span class="recovery-confirmation__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="m5 12 4 4L19 6" />
          </svg>
        </span>
        <h2>{{ 'login.checkEmail' | translate }}</h2>
        <p class="subtitle">{{ 'login.checkEmailHelp' | translate }}</p>
        <button class="submit-button" type="button" (click)="closeRecovery()">
          {{ 'login.back' | translate }}
        </button>
      </div>
      }

      <div class="login-card__footer">
        <span>{{ 'login.restricted' | translate }}</span>
      </div>
    </section>
  </div>
</div>
